/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.sync.getBlob'

export { $nsid }

/** Get a blob associated with a given account. Returns the full blob as originally uploaded. Does not require auth; implemented by PDS. */
const main = l.query(
  $nsid,
  l.params({
    did: l.string({ format: 'did' }),
    cid: l.string({ format: 'cid' }),
  }),
  l.payload('*/*'),
  [
    'BlobNotFound',
    'RepoNotFound',
    'RepoTakendown',
    'RepoSuspended',
    'RepoDeactivated',
  ],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
